import React from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { FaFileContract, FaUserShield } from 'react-icons/fa';
import Modal from './Modal';
import {
  FaFacebookF,
  FaLinkedinIn,
  FaGithub,
  FaPhoneAlt,
  FaEnvelope,
  FaInstagram,
  FaMapMarkerAlt,
  FaGoogle,
  FaYoutube,
} from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6'; // use this for new X logo


const Footer = () => {
  const [showLegalModal, setShowLegalModal] = React.useState(false);
  const [legalSection, setLegalSection] = React.useState('privacy');
  return (
    <footer className="bg-gradient-to-r from-[#0B0D1C] via-[#111325] to-[#0B0D1C] text-white px-6 py-16">
  <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-6 gap-y-10 gap-x-12 text-center md:text-left">

        {/* Logo & Description */}
        <div className="flex flex-col items-center sm:items-start">
          <img src="/MASRIQ.png" alt="MASRIQ Logo" className="w-24 h-24 md:w-20 md:h-20 mb-2 mx-auto md:mx-0" />
          <h2 className="text-2xl font-bold text-cyan-400 mb-4 text-center md:text-left">MASRIQ NextTech Solutions</h2>
          <p className="text-white/90 text-sm mb-4 leading-relaxed text-center md:text-left">
            Driving innovation through AI, Vision, Cloud & more. <br />
            Building the future with passion & purpose.
          </p>
          <p className="text-white/80 text-xs text-center md:text-left"><a href="https://maps.app.goo.gl/t4tUC3LDisW9d6N7A" target="_blank" rel="noopener noreferrer" className="hover:text-cyan-400 transition">
            📍 Old No. 663, New 2/2, 4th Main Road, Vyalikaval, Bengaluru, India - 560 003</a>
          </p>
        </div>

        {/* Quick Links */}
        <div className="flex flex-col items-center sm:items-start">
          <h3 className="text-xl font-semibold text-cyan-300 mb-4 md:text-left">Quick Links</h3>
          <ul className="space-y-2 text-white/80 text-sm md:text-left">
            {["Home", "About", "Products", "Ourworks", "Services", "Quote", "Team", "Careers", "Blogs"].map((link) => (
              <li key={link}>
                {link === "Blogs" ? (
                  <Link
                    to="/blogs"
                    className="hover:text-cyan-400 transition duration-300 hover:pl-1"
                  >
                    {link}
                  </Link>
                ) : (
                  <HashLink
                    smooth
                    to={`/#${link.toLowerCase()}`}
                    className="hover:text-cyan-400 transition duration-300 hover:pl-1"
                  >
                    {link}
                  </HashLink>
                )}
              </li>
            ))}
          </ul>
        </div>

        {/* Portfolios */}
        <div className="flex flex-col items-center sm:items-start">
          <h3 className="text-xl font-semibold text-cyan-300 mb-4 md:text-left">Portfolios</h3>
          <ul className="space-y-2 text-white/80 text-sm md:text-left">
          <li><Link to="/sawoodPortfolio" className="hover:text-cyan-400 transition duration-300 hover:pl-1">Sawood</Link></li>
          <li><Link to="/massoodhPortfolio" className="hover:text-cyan-400 transition duration-300 hover:pl-1">Massoodh</Link></li>
          <li><Link to="/iqlaasPortfolio" className="hover:text-cyan-400 transition duration-300 hover:pl-1">Iqlaas</Link></li>
          <li><Link to="/roshanPortfolio" className="hover:text-cyan-400 transition duration-300 hover:pl-1">Roshan</Link></li>
          <li><Link to="/riyaPortfolio" className="hover:text-cyan-400 transition duration-300 hover:pl-1">Riya</Link></li>
            <li><Link to="/abdulPortfolio" className="hover:text-cyan-400 transition duration-300 hover:pl-1">Abdul</Link></li>
            <li><Link to="/aymanPortfolio" className="hover:text-cyan-400 transition duration-300 hover:pl-1">Ayman</Link></li>
            <li><Link to="/eisaPortfolio" className="hover:text-cyan-400 transition duration-300 hover:pl-1">Eisa</Link></li>
            
          </ul>
        </div>

        {/* Products Quick Links */}
        <div className="flex flex-col items-center sm:items-start">
          <h3 className="text-xl font-semibold text-cyan-300 mb-4 md:text-left">Products</h3>
          <ul className="space-y-2 text-white/80 text-sm md:text-left">
            <li>
              <a href="https://eventmate-ai.com" className="hover:text-cyan-400 transition duration-300 hover:pl-1">EventMate-Ai</a>
            </li>
            <li>
              <a href="#BusinnessAlarm" className="hover:text-cyan-400 transition duration-300 hover:pl-1">Business Alarm</a>
            </li>
            <li>
              <a href="https://eventmateai.netlify.app" className="hover:text-cyan-400 transition duration-300 hover:pl-1">EventMate-Ai Application</a>
            </li>
          </ul>
        </div>

        {/* Contact Us */}
        <div className="flex flex-col items-center sm:items-start">
          <h3 className="text-xl font-semibold text-cyan-300 mb-4 md:text-left">Contact Us</h3>
          <ul className="space-y-4 text-white/80 text-sm md:text-left">
            <li className="flex items-center gap-3 justify-center sm:justify-start">
              <FaEnvelope className="text-cyan-400" />
              <a href="mailto:info@masriq.tech" className="hover:text-cyan-400 transition">
                info@masriq.tech
              </a>
            </li>
            <li className="flex items-center gap-3 justify-center sm:justify-start">
              <FaPhoneAlt className="text-cyan-400" />
              <a href="tel:+919902806732" className="hover:text-cyan-400 transition">
                +91 99028 06732
              </a>
            </li>
          </ul>
        </div>

        <div className="flex flex-col items-center sm:items-start">
          <h3 className="text-xl font-semibold text-cyan-300 mb-4 md:text-left">Follow Us</h3>
          <div className="flex gap-4 text-xl mb-6 justify-center md:justify-start">
            <a href="https://www.facebook.com/masriqnxttech" target="_blank" rel="noopener noreferrer"
              className="floating-icon text-white hover:text-blue-400 transition hover:drop-shadow-[0_0_10px_#00FFFF]" aria-label='Facebook' title='Facebook'>
              <FaFacebookF />
            </a>
            <a href="https://www.linkedin.com/company/masriqnxtech/" target="_blank" rel="noopener noreferrer"
              className="floating-icon text-white hover:text-blue-300 transition hover:drop-shadow-[0_0_10px_#00FFFF]" aria-label='LinkedIn' title='LinkedIn'>
              <FaLinkedinIn />
            </a>
            <a href="https://github.com/organizations/MASRIQ-NextTech-Solutions/" target="_blank" rel="noopener noreferrer"
              className="floating-icon text-white hover:text-gray-200 transition hover:drop-shadow-[0_0_10px_#00FFFF]" aria-label='GitHub' title='GitHub'>
              <FaGithub />
            </a>
            <a href="https://www.instagram.com/masriqnext.tech/" target="_blank" rel="noopener noreferrer"
              className="floating-icon text-white hover:text-pink-400 transition hover:drop-shadow-[0_0_10px_#00FFFF]" aria-label='Instagram' title='Instagram'>
              <FaInstagram />
            </a>
            <a href="https://x.com/Masriqnxtech" target="_blank" rel="noopener noreferrer"
              className="floating-icon text-white hover:text-cyan-400 transition hover:drop-shadow-[0_0_10px_#00FFFF]" aria-label="X (Twitter)" title='X (Twitter)'>
              <FaXTwitter />
            </a>
            <a href="https://share.google/VEk6ZO32Ake5Zc2xY" target="_blank" rel="noopener noreferrer"
              className="floating-icon text-white hover:text-green-400 transition hover:drop-shadow-[0_0_10px_#00FFFF]"
              aria-label="Google Maps Location" title='Google Maps Location'>
              <FaMapMarkerAlt />
            </a>
            <a href="https://g.page/r/CQd1RN3sZ3yIEBM/review" target="_blank" rel="noopener noreferrer"
              className="floating-icon text-white hover:text-yellow-400 transition hover:drop-shadow-[0_0_10px_#00FFFF]"
              aria-label="Google Reviews" title='Google Reviews'>
              <FaGoogle />
            </a>
            <a href="https://www.youtube.com/@MASRIQNextTechSolutions" target="_blank" rel="noopener noreferrer"
              className="floating-icon text-white hover:text-red-400 transition hover:drop-shadow-[0_0_10px_#00FFFF]"
              aria-label="Youtube" title='Youtube'>
              <FaYoutube />
            </a>
          </div>
        </div>

        {/* Subscribe - now in its own column */}
        <div className="flex flex-col items-center sm:items-start">
          <h3 className="text-xl font-semibold text-cyan-300 mb-4 md:text-left">Subscribe</h3>
          <form onSubmit={(e) => { e.preventDefault(); alert('Subscribed!'); }} className="w-full flex flex-col items-center md:items-start md:text-left">
            <input
              type="email"
              required
              placeholder="Your email"
              className="w-full px-3 py-2 rounded-md bg-[#1C1E2F] text-sm text-white placeholder-white/60 focus:outline-none focus:ring-2 focus:ring-cyan-400 text-center md:text-left mb-4"
            />
            <button
              type="submit"
              className="w-full bg-gradient-to-r from-purple-500 to-cyan-400 px-4 py-2 rounded-md text-white font-medium hover:scale-105 transition-all"
            >
              Subscribe
            </button>
          </form>
        </div>
      </div>

  {/* Legal Links */}
  <div className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-8 mt-10 mb-2">
        <button
          className="flex items-center gap-2 text-white font-semibold hover:text-yellow-400 transition duration-300"
          style={{ background: 'none', border: 'none', boxShadow: 'none', padding: 0 }}
          onClick={() => { setLegalSection('privacy'); setShowLegalModal(true); }}
        >
          <FaUserShield className="text-xl" /> Privacy Policy
        </button>
        <button
          className="flex items-center gap-2 text-white font-semibold hover:text-purple-400 transition duration-300"
          style={{ background: 'none', border: 'none', boxShadow: 'none', padding: 0 }}
          onClick={() => { setLegalSection('terms'); setShowLegalModal(true); }}
        >
          <FaFileContract className="text-xl" /> Terms of Service
        </button>
      </div>

      {/* Legal Modal */}
      <Modal isOpen={showLegalModal} onClose={() => setShowLegalModal(false)}>
        <div className="w-full max-w-4xl mx-auto px-2 sm:px-6 py-4 relative">
          <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 mb-6 justify-center items-center">
            <button
              className={`flex items-center gap-2 text-white font-bold hover:text-yellow-400 transition duration-300 bg-none border-none shadow-none px-2 py-1 ${legalSection === 'privacy' ? '' : 'opacity-60'}`}
              style={{ background: 'none', border: 'none', boxShadow: 'none', padding: 0 }}
              onClick={() => setLegalSection('privacy')}
            >
              <FaUserShield className="text-xl" /> Privacy Policy
            </button>
            <button
              className={`flex items-center gap-2 text-white font-bold hover:text-purple-400 transition duration-300 bg-none border-none shadow-none px-2 py-1 ${legalSection === 'terms' ? '' : 'opacity-60'}`}
              style={{ background: 'none', border: 'none', boxShadow: 'none', padding: 0 }}
              onClick={() => setLegalSection('terms')}
            >
              <FaFileContract className="text-xl" /> Terms of Service
            </button>
            {/* Removed duplicate close button, only Modal's close button remains */}
          </div>
          <div className="overflow-y-auto max-h-[70vh] sm:max-h-[60vh] px-2">
            {legalSection === 'privacy' ? (
              <div>
                <h1 className="text-2xl sm:text-4xl font-extrabold mb-6 sm:mb-8 text-center bg-gradient-to-r from-yellow-400 via-blue-600 to-purple-600 bg-clip-text text-transparent drop-shadow-lg">Privacy Policy</h1>
                <p className="mb-6 sm:mb-8 text-base sm:text-lg text-white text-center">MASRIQ NextTech Solutions is committed to protecting your privacy. This policy explains how we handle your information for all our stakeholders.</p>
                <div className="mb-8 sm:mb-10">
                  <h2 className="text-lg sm:text-2xl font-bold mb-2 sm:mb-3 text-blue-400">1. Privacy Policy for Users/Clients</h2>
                  <ul className="list-disc list-inside mb-2 sm:mb-4 text-white/90">
                    <li>We collect and process personal information (name, email, phone, company details) to provide quotations, deliver services, and support your experience.</li>
                    <li>Data is stored securely and only used for service delivery, support, and legal compliance.</li>
                    <li>We do not sell or share your data with third parties except as required by law.</li>
                  </ul>
                </div>
                <div className="mb-8 sm:mb-10">
                  <h2 className="text-lg sm:text-2xl font-bold mb-2 sm:mb-3 text-purple-400">2. Privacy Policy for Investors</h2>
                  <ul className="list-disc list-inside mb-2 sm:mb-4 text-white/90">
                    <li>Investor information (name, contact, financial details) is handled with strict confidentiality.</li>
                    <li>Data is used solely for investment management, reporting, and regulatory compliance.</li>
                    <li>We maintain robust security measures and do not disclose investor data without explicit consent or legal requirement.</li>
                  </ul>
                </div>
                <div className="mb-8 sm:mb-10">
                  <h2 className="text-lg sm:text-2xl font-bold mb-2 sm:mb-3 text-green-400">3. Privacy Policy for Partners</h2>
                  <ul className="list-disc list-inside mb-2 sm:mb-4 text-white/90">
                    <li>Partner data (business contacts, agreements, communications) is used to manage collaborations, joint projects, and business development.</li>
                    <li>We protect partner information and only share it as necessary for partnership activities or legal obligations.</li>
                  </ul>
                </div>
                <div className="mb-8 sm:mb-10">
                  <h2 className="text-lg sm:text-2xl font-bold mb-2 sm:mb-3 text-pink-400">4. Privacy Policy for Students/Interns</h2>
                  <ul className="list-disc list-inside mb-2 sm:mb-4 text-white/90">
                    <li>We collect intern/student data (name, contact, educational background) for recruitment, onboarding, and program management.</li>
                    <li>Data is kept confidential and used only for internship administration and legal compliance.</li>
                  </ul>
                </div>
                <div className="mb-8 sm:mb-10">
                  <h2 className="text-lg sm:text-2xl font-bold mb-2 sm:mb-3 text-red-400">5. Privacy Policy for Employees</h2>
                  <ul className="list-disc list-inside mb-2 sm:mb-4 text-white/90">
                    <li>Employee data (personal, payroll, performance) is collected for HR, payroll, and legal purposes.</li>
                    <li>We ensure employee privacy and only share data with authorized personnel or as required by law.</li>
                  </ul>
                </div>
                <div className="mb-8 sm:mb-10">
                  <h2 className="text-base sm:text-xl font-bold mb-1 sm:mb-2 text-yellow-300">General Rights</h2>
                  <ul className="list-disc list-inside mb-2 sm:mb-4 text-white/90">
                    <li>All individuals may request access, correction, or deletion of their data by contacting <a href="mailto:info@masriq.tech" className="text-blue-300 underline">info@masriq.tech</a>.</li>
                    <li>We comply with applicable data protection laws and strive to maintain the highest standards of privacy.</li>
                  </ul>
                </div>
                <p className="mb-2 text-center text-white">For questions or concerns, please contact us at <a href="mailto:info@masriq.tech" className="text-blue-300 underline">info@masriq.tech</a>.</p>
              </div>
            ) : (
              <div>
                <h1 className="text-2xl sm:text-4xl font-extrabold mb-6 sm:mb-8 text-center bg-gradient-to-r from-purple-400 via-blue-600 to-yellow-400 bg-clip-text text-transparent drop-shadow-lg">Terms of Service</h1>
                  <div className="mb-8 sm:mb-10">
                    <h2 className="text-lg sm:text-2xl font-bold mb-2 sm:mb-3 text-blue-400">1. Terms for Users/Clients</h2>
                    <ul className="list-disc list-inside mb-2 sm:mb-4 text-white/90">
                      <li>Quotations are estimates and may change based on final requirements.</li>
                      <li>Services are delivered as per the agreed scope, timeline, and payment terms.</li>
                      <li>Support and maintenance are provided as per the selected plan.</li>
                      <li>At least 25% advance to be paid. Max can be 50% of the total bill once the quote is confirmed.</li>
                      <li>Once the MVP is submitted we only accept minor changes, not major ones.</li>
                      <li>If any extra page or screen is requested upon the quotation generated, we will be charging per page (Extra Pages).</li>
                      <li>Disputes are resolved under the jurisdiction of our registered location.</li>
                    </ul>
                  </div>
                  <div className="mb-8 sm:mb-10">
                    <h2 className="text-lg sm:text-2xl font-bold mb-2 sm:mb-3 text-purple-400">2. Terms for Investors</h2>
                    <ul className="list-disc list-inside mb-2 sm:mb-4 text-white/90">
                      <li>Investments are subject to due diligence, risk assessment, and regulatory compliance.</li>
                      <li>Returns, reporting, and disclosures are managed transparently.</li>
                      <li>Investor relations are governed by signed agreements and applicable laws.</li>
                    </ul>
                  </div>
                  <div className="mb-8 sm:mb-10">
                    <h2 className="text-lg sm:text-2xl font-bold mb-2 sm:mb-3 text-green-400">3. Terms for Partners</h2>
                    <ul className="list-disc list-inside mb-2 sm:mb-4 text-white/90">
                      <li>Partnerships are governed by mutual agreements outlining roles, responsibilities, and deliverables.</li>
                      <li>Confidentiality and non-disclosure terms apply to all shared information.</li>
                      <li>Disputes are resolved through negotiation or legal channels as specified in agreements.</li>
                    </ul>
                  </div>
                  <div className="mb-8 sm:mb-10">
                    <h2 className="text-lg sm:text-2xl font-bold mb-2 sm:mb-3 text-pink-400">4. Terms for Students/Interns</h2>
                    <ul className="list-disc list-inside mb-2 sm:mb-4 text-white/90">
                      <li>Internship offers are subject to eligibility and program requirements.</li>
                      <li>Interns must comply with company policies and confidentiality agreements.</li>
                      <li>Completion certificates and recommendations are provided based on performance.</li>
                      <li>Payment/Stipend will depend on the project type and the work carried by the intern.</li>
                    </ul>
                  <div className="mb-8 sm:mb-10">
                    <h2 className="text-base sm:text-xl font-bold mb-1 sm:mb-2 text-orange-300">Payments & Refunds</h2>
                    <ul className="list-disc list-inside mb-2 sm:mb-4 text-white/90">
                      <li>If the advance is paid, only 1 whole day will be available to cancel the project. If cancelled within 1 day, all the advance paid will be refunded.</li>
                      <li>If the project is started and you cancel it, only 25% of the advance will be returned.</li>
                      <li>If the front end is completed and you cancel the project, no amount will be refunded.</li>
                      <li>If the project is near to its completion (85% complete) and you cancel it, you will have to pay a fine of 10% of the total bill as an extra with 50% advance.</li>
                      <li>If the project is cancelled and no NDA, etc. has been signed, then the project, code, etc. belongs to MASRIQ NextTech Solutions.</li>
                    </ul>
                  </div>
                  </div>
                  <div className="mb-8 sm:mb-10">
                    <h2 className="text-lg sm:text-2xl font-bold mb-2 sm:mb-3 text-red-400">5. Terms for Employees</h2>
                    <ul className="list-disc list-inside mb-2 sm:mb-4 text-white/90">
                      <li>Employment is governed by signed contracts, company policies, and labor laws.</li>
                      <li>Employees must adhere to code of conduct, confidentiality, and performance standards.</li>
                      <li>Termination, benefits, and grievance procedures are outlined in HR policies.</li>
                    </ul>
                  </div>
                  <div className="mb-8 sm:mb-10">
                    <h2 className="text-base sm:text-xl font-bold mb-1 sm:mb-2 text-yellow-300">General Terms</h2>
                    <ul className="list-disc list-inside mb-2 sm:mb-4 text-white/90">
                      <li>By using our services, investing, partnering, or joining as an intern/employee, you agree to these terms.</li>
                      <li>For questions, contact <a href="mailto:info@masriq.tech" className="text-blue-300 underline">info@masriq.tech</a>.</li>
                    </ul>
                  </div>
                  <p className="mb-2 text-center text-white">For full details, please contact us at <a href="mailto:info@masriq.tech" className="text-blue-300 underline">info@masriq.tech</a>.</p>
              </div>
            )}
          </div>
        </div>
      </Modal>
      {/* Bottom Line */}
      <div className="border-t border-white/10 mt-12 pt-6 text-center text-white/40 text-xs">
        © {new Date().getFullYear()} MASRIQ NextTech Solutions. All rights reserved.
      </div>
    </footer >
  );
};

export default Footer;
